/**
 * Typed access to import.meta.env values.
 *
 * Add new VITE_* keys to vite-env.d.ts and re-export them here so the
 * rest of the app reads from a single, validated source.
 */
export const env = {
  appName: import.meta.env.VITE_APP_NAME ?? "Trapped Capacity Index Calculator",
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? "",
  googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID ?? "",
  /** Google Calendar Appointment Scheduling URL for "Book a Session" */
  bookingUrl: import.meta.env.VITE_BOOKING_URL ?? "",
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const;

export type Env = typeof env;
